import React, { useContext } from "react";
import PropTypes from "prop-types";
import { RichText, Text } from "./base/index";
import { PageStateContext } from '../PageContext';


const YoutubeVideoLink = ({ url, paragraph, className, handleAnchor }) => {
  const { pageState } = useContext(PageStateContext);
  if (!pageState || !pageState.uiText) {
    return (
      <div className="header-loading">
        <span>Loading Link...</span>
      </div>
    );
  }  
  const { uiText } = pageState;
  const label = `${uiText.print_video_watch}`;
  const urlSanitized = `${url}`;
  return (
    <div className={className}>
      {url && typeof url === "string" && url !== "" && url !== " " && (
        <Text tag="p">{label}:</Text>
      )}
      {paragraph &&
        typeof paragraph === "string" &&
        paragraph !== "" &&
        paragraph !== " " && (
          <RichText html={paragraph} handleAnchor={handleAnchor} />
        )}
      {url && typeof url === "string" && url !== "" && url !== " " && (
        <div>
          <a href={urlSanitized} target="_blank" rel="noopener noreferrer">
            <Text tag="span" use="p" className="text-blue-accent">
              {urlSanitized}
            </Text>
          </a>
        </div>
      )}
    </div>
  );
};

YoutubeVideoLink.propTypes = {
  url: PropTypes.string.isRequired,
  paragraph: PropTypes.string,
  className: PropTypes.string,
  handleAnchor: PropTypes.func,
};

YoutubeVideoLink.defaultProps = {
  className: "",
  paragraph: null,
};

export default YoutubeVideoLink;
